import { FC } from "react";
import useEvent from "react-use-event-hook";

import { useDrawers } from "@ryde/shared";

import { RELATED_ENTITIES_IDS_JOIN_DELIMITER } from "./related-entities.constants";
import { LinkToRelatedEntityStyled } from "./related-entities.styled";
import { openRelatedEntityEdit } from "./related-entities.utils";

interface IRelatedEntitiesRowIds {
  relation: string;
  ids: number[];
  onEntityClick: () => void;
}

export const RelatedEntitiesRowIds: FC<IRelatedEntitiesRowIds> = ({
  relation,
  ids,
  onEntityClick,
}) => {
  const {
    openEditFormDrawer,
    openRideEditFormDrawer,
    openBookingEditFormDrawer,
  } = useDrawers();

  const onEditLinkClick = useEvent(async (id: number) => {
    await openRelatedEntityEdit({
      relation,
      id,
      onCloseAction: onEntityClick,
      openRideEditFormDrawer,
      openBookingEditFormDrawer,
      openEditFormDrawer,
    });
  });

  return (
    <td className="relation-ids-cell">
      {ids.map((id, index) => (
        <span key={id}>
          <LinkToRelatedEntityStyled onClick={() => onEditLinkClick(id)}>
            {id}
          </LinkToRelatedEntityStyled>
          {index < ids.length - 1 && RELATED_ENTITIES_IDS_JOIN_DELIMITER}
        </span>
      ))}
    </td>
  );
};
